import type { RandomSpaceAccessPublicConfig } from "./HomeModel";
import { MOCK_KNOWN_SPACES } from "../../global/GlobalMock";

export function mockCheckSpaceExists(spaceId: string): boolean {
  return /^\d{8}$/.test(spaceId) && spaceId in MOCK_KNOWN_SPACES;
}

export const mockRandomSpaceAccessConfig: RandomSpaceAccessPublicConfig = {
  enabled: false,
  candidates: ["10000011", "10000012", "32230303"],
  bigButton: false,
  buttonText: "为我推荐",
};
